package one.healthium.insights.ui.insights.models

import one.healthium.loco.LString
import androidx.compose.runtime.Immutable

@Immutable
data class EmptyUiModel(
    val title: LString,
    val message: LString,
)
